import ReadsMap, { getReadsMapHeight } from './ReadsMap';
export { getReadsMapHeight };
export default ReadsMap;
